/* custom cart product-list */
class CartProductList extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    
    this.addCartProductEvent();
  }
  addCartProductEvent() {
    this.querySelectorAll('.cart-product-item').forEach((product) => {
      product.addEventListener('click', (event) => {
        const productId = product.dataset.productId;
        const variant_id = product.dataset.variant;
        this.addInfoBox();
        if (product.classList.contains('active')) {
          this.infoBox.textContent = 'An item is being deleted...';
          let updates = {};
          updates[`${variant_id}`] = 0;
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          })
          .then((res) => {
            window.location.reload();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        } else {
          this.infoBox.textContent = 'An item is loading...';
          let formData = {
            items: [{
              quantity: 1,
              'product-id': productId,
              id: variant_id,
              form_type: 'product'
            }],
          };
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then((res) => {
            window.location.reload();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        }
      });
    });
  }

  addInfoBox() {
    this.infoBox = document.createElement('div');
    this.infoBox.classList.add('cart-info-box');
    document.body.appendChild(this.infoBox);
  }
  
  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.update();
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const containerRect = this.slider.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    return ( elementRect.left >= containerRect.left && elementRect.right <= containerRect.right );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
      behavior: 'smooth'
    });
  }
}
customElements.define('cart-product-list', CartProductList);

class CouponItem extends HTMLElement {
  constructor() {
    super(),
    this.init()
  }
  init() {
    this.copdy = this.querySelector(".copy_code_btn");
    this.copdy && this.copdy.addEventListener("click", e => {
      this.copyToClipboard(this.copdy.dataset.code),
      this.copdy.innerText = "copied!",
      setTimeout(() => {
        this.copdy.innerText = "copy"
      }, 1500);
    });
  }
  copyToClipboard(str) {
    let el = document.createElement("textarea");
    el.value = str,
    el.setAttribute("readonly", ""),
    el.style.position = "absolute",
    el.style.left = "-9999px",
    document.body.appendChild(el);
    let selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : !1;
    el.select(),
    document.execCommand("copy"),
    document.body.removeChild(el),
    selected && (document.getSelection().removeAllRanges(),
    document.getSelection().addRange(selected))
  }
}
customElements.define("coupon-item", CouponItem);

class ProductJoinvip extends HTMLElement {
  constructor() {
    super();
    const productVipAskEl = this.querySelector('.product-vip-ask');
    
    this.addEventListener('click', e => {
      if (!email && e.target != productVipAskEl) {
        if (typeof gtag === 'function') { gtag('event', 'vip_signup'); }
        const signbox = document.body.querySelector('login-register');
        signbox.classList.add('active');
        signbox.querySelector('.signup-item').click();
      }
    });
    this.toolTipEl = this.querySelector('.vip-tooltip');
    
    productVipAskEl.addEventListener('click', e => {
      this.toolTipEl.classList.add('active');
      setTimeout(()=> {
        this.toolTipOutsideEvent();
      },1000);        
    });      
  }
  toolTipOutsideEvent() {
    document.body.addEventListener('click', this.toolTipOutsideHandle);
  }
  toolTipOutsideHandle = (e) => {
    if(e.target != this.toolTipEl && this.toolTipEl.classList.contains('active')) {
      this.toolTipEl.classList.remove('active');
      document.body.removeEventListener('click', this.toolTipOutsideHandle);
    }
  }
}
customElements.define('product-join-vip', ProductJoinvip);

// buy-it-now for main-product
document.body.querySelector('#buy-it-now')?.addEventListener('click', (e)=> {
  e.preventDefault();
  if (document.body.querySelector('#more-payment-options-link')) {
    document.body.querySelector('#more-payment-options-link').click();
  } else {
    document.body.querySelector('shopify-buy-it-now-button .shopify-payment-button__button').click();
  }  
});

// PRODUCT VIDEO SLIDE
class ProductVideoSlide extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    
    this.videoModal = this.querySelector('.product-video-slide__modal');
    this.videoModalClose = this.querySelector('.product-video-slide__modal-close');
    this.videoProductBox = this.querySelector('.product-video-box');
    this.videoMuteButton = this.querySelector('.product-video-slide__modal-mute');      
    this.videoPrevButton = this.querySelector('.product-video-slide__modal-nav__prev');
    this.videoNextButton = this.querySelector('.product-video-slide__modal-nav__next');

    this.currentIndex = 1;
    this.indexLen = this.sliderItems.length;

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    this.addVideoEvent();
  }

  updateVideoModalInfo() {
    this.videoProductBox.classList.add('loading');
    
    const item = this.querySelector(`#Slide-cart-product-${this.currentIndex}`);
    // this.videoProductBox.style = `background-image:url(${item.dataset.poster});background-size:100% 100%;background-repeat:no-repeat;`;
    this.querySelector('.product-video-slide__modal-title').innerText = item.dataset.title;
    this.videoProductBox.innerHTML = `
      <video class="product-video-slide__modal-video" preload="auto" autoplay playsinline webkit-playsinline muted loop poster="${item.dataset.poster}" src="${item.dataset.video}" >
        <source src="${item.dataset.video}">
        Your browser doesn't support the video tag. You can
        <a href="${item.dataset.video }">download the video here.</a>
      </video>
      <a href="${item.dataset.url}" title="${item.dataset.title}" class="product-video-slide__product-card">
        <div class="product-card__content">
          <img srcset="${item.dataset.img}" alt="${item.dataset.title}" loading="lazy" />
          <div class="product-card__info">
            <div class="product-card__title">${item.dataset.title}</div>
            <div class="product-card__price"><span class="current-price">${item.dataset.price}</span><span class="compare-price">${item.dataset.price}</span></div>
            <div class="product-card__button">Shop Now</div>
          </div>
        </div>
      </a>`;
    
    if (this.currentIndex > 1) {
      if (this.videoPrevButton.classList.contains('hide')) this.videoPrevButton.classList.remove('hide');
    } else {
      if (!this.videoPrevButton.classList.contains('hide')) this.videoPrevButton.classList.add('hide');
    }      
    
    if (this.currentIndex < this.indexLen) {
      if (this.videoNextButton.classList.contains('hide')) this.videoNextButton.classList.remove('hide');
    } else {
      if (!this.videoNextButton.classList.contains('hide')) this.videoNextButton.classList.add('hide');
    }

    this.currentVideo = this.querySelector('.product-video-slide__modal-video');
    setTimeout(()=> {
      this.currentVideo.muted = false;        
    }, 1000);
    
    this.videoMuteButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M11.536 14.01A8.47 8.47 0 0 0 14.026 8a8.47 8.47 0 0 0-2.49-6.01l-.708.707A7.48 7.48 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303z"/><path d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.48 5.48 0 0 1 11.025 8a5.48 5.48 0 0 1-1.61 3.89z"/><path d="M10.025 8a4.5 4.5 0 0 1-1.318 3.182L8 10.475A3.5 3.5 0 0 0 9.025 8c0-.966-.392-1.841-1.025-2.475l.707-.707A4.5 4.5 0 0 1 10.025 8M7 4a.5.5 0 0 0-.812-.39L3.825 5.5H1.5A.5.5 0 0 0 1 6v4a.5.5 0 0 0 .5.5h2.325l2.363 1.89A.5.5 0 0 0 7 12zM4.312 6.39 6 5.04v5.92L4.312 9.61A.5.5 0 0 0 4 9.5H2v-3h2a.5.5 0 0 0 .312-.11"/></svg>';
    
    setTimeout(()=> { if(this.currentVideo.paused) this.currentVideo.play(); }, 2000);
    
    this.currentVideo.addEventListener("play", () => {
      if (this.videoProductBox.classList.contains('loading')) this.videoProductBox.classList.remove('loading');
    }, false);
  }

  timerCallback() {
    if (this.currentVideo.paused || this.currentVideo.ended) {
      return;
    }
    this.canvasVideo.getContext("2d").drawImage(this.currentVideo, 0, 0, this.cwidth, this.cheight);
    setTimeout(() => {
      this.timerCallback();
    }, 1000 / 60);
  }

  addVideoEvent() {
    this.sliderItems.forEach((item, idx) => {
      item.querySelector('.product-video-slide__play').addEventListener('click', (e) => {
        if (item.dataset.video) {
          this.videoModal.classList.remove('hide');
          this.currentIndex = idx + 1;
          this.updateVideoModalInfo();
        }
      });
    });
    
    this.videoModalClose.addEventListener('click', (e) => {
      this.videoProductBox.innerHTML = "";
      this.videoModal.classList.add('hide');
    });

    this.videoMuteButton.addEventListener('click', (e) => {
      if (this.currentVideo) {
        this.currentVideo.muted = !this.currentVideo.muted;
        if(this.currentVideo.muted) {
          this.videoMuteButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06M6 5.04 4.312 6.39A.5.5 0 0 1 4 6.5H2v3h2a.5.5 0 0 1 .312.11L6 10.96zm7.854.606a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0"/></svg>';
        } else {
          this.videoMuteButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M11.536 14.01A8.47 8.47 0 0 0 14.026 8a8.47 8.47 0 0 0-2.49-6.01l-.708.707A7.48 7.48 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303z"/><path d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.48 5.48 0 0 1 11.025 8a5.48 5.48 0 0 1-1.61 3.89z"/><path d="M10.025 8a4.5 4.5 0 0 1-1.318 3.182L8 10.475A3.5 3.5 0 0 0 9.025 8c0-.966-.392-1.841-1.025-2.475l.707-.707A4.5 4.5 0 0 1 10.025 8M7 4a.5.5 0 0 0-.812-.39L3.825 5.5H1.5A.5.5 0 0 0 1 6v4a.5.5 0 0 0 .5.5h2.325l2.363 1.89A.5.5 0 0 0 7 12zM4.312 6.39 6 5.04v5.92L4.312 9.61A.5.5 0 0 0 4 9.5H2v-3h2a.5.5 0 0 0 .312-.11"/></svg>';
        }
      }
    });

    this.videoPrevButton.addEventListener('click', (e) => {
      if (this.currentIndex > 1) this.currentIndex -= 1;
      this.updateVideoModalInfo();        
    });
    
    this.videoNextButton.addEventListener('click', (e) => {
      if (this.currentIndex < this.indexLen)  this.currentIndex += 1;        
      this.updateVideoModalInfo();        
    });      
  }
  
  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.update();
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.classList.add('hide');
    } else {
      this.prevButton.classList.remove('hide');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.classList.add('hide');
    } else {
      this.nextButton.classList.remove('hide');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
      behavior: 'smooth'
    });
  }
}
customElements.define('product-video-slide', ProductVideoSlide);

// back-to-top
if (!customElements.get("back-to-top")) {
  class BackToTop extends HTMLElement {
    constructor() {
      super(),
      this.pageHeight = window.innerHeight
    }
    connectedCallback() {
      this.addEventListener("click", this.onClick),
      this.addEventListener("touchstart", this.onClick, { passive: !0  }),
      window.addEventListener("scroll", this.checkVisible.bind(this))
    }
    checkVisible(event) {
      window.requestAnimationFrame( () => {
        window.scrollY > this.pageHeight * 1.5 ? this.classList.add("active") : this.classList.remove("active")
      })
    }
    onClick() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      })
    }
  }
  customElements.define("back-to-top", BackToTop)
}

// custom-footer-title
if (!customElements.get("custom-footer-title")) {
  class CustomFooterTitle extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      this.addEventListener('click', (e) => {
        e.preventDefault();
        const parentEl = this.parentElement;
        if (parentEl?.classList.contains('active')) {
          parentEl?.classList.remove('active');
        } else {
          parentEl?.classList.add('active');
        }        
      });
    }
  }
  customElements.define("custom-footer-title", CustomFooterTitle)
}

// custom reviews for main-product
if (!customElements.get("custom-reviews")) {
  class CustomReviews extends HTMLElement {
    constructor() {
      super();

      this.init();
    }

    init() {
      this.addEventListener('click', (event) => {
        this.scrollEvent();
      });
    }

    scrollEvent() {
      let productTabEl = document.querySelector('custom-tab') || document.body.querySelector('#judgeme_product_reviews');
      if (productTabEl) {
        const tabNavEl = document.body.querySelector('.tabs-nav');
        if (window.getComputedStyle(tabNavEl).display == 'block') {
          tabNavEl.querySelector('.reviews-desktop').click();
        } else {
          document.body.querySelector('.reviews-mobile').click();
        }
        setTimeout(() => {          
          let scrolltop = productTabEl.getBoundingClientRect().top  + window.pageYOffset;
          window.scrollTo({
            behavior: 'smooth',
            top: parseInt(scrolltop)
          });
        }, 160);
      }
    }
  }
  customElements.define('custom-reviews', CustomReviews);
}

// product-payment-container for product-form
if (!customElements.get("product-payment-container")) {
  class ProductPaymentContainer extends HTMLElement {
    constructor() {
      super();
      this.buyItNow = this.querySelector('#buy-it-now');
      this.init();
    }

    init() {
      this.buyItNow?.addEventListener('click', (e)=> {
        e.preventDefault();
        if (this.querySelector('#more-payment-options-link')) {
          this.querySelector('#more-payment-options-link').click();
        } else {
          this.querySelector('shopify-buy-it-now-button .shopify-payment-button__button').click();
        }  
      });
    }
  }
  customElements.define('product-payment-container', ProductPaymentContainer);
}

if (!customElements.get("countries-selector")) {
    let curent_country = window.localStorage.getItem('country')?.toLocaleUpperCase() || Shopify.country;
    const cmap = {
        EU: "EUR",
        BD: "BDT",
        BE: "EUR",
        BF: "XOF",
        BG: "EUR",
        BA: "BAM",
        BB: "BBD",
        WF: "XPF",
        BL: "EUR",
        BM: "BMD",
        BN: "BND",
        BO: "BOB",
        BH: "BHD",
        BI: "BIF",
        BJ: "XOF",
        BT: "BTN",
        JM: "JMD",
        BV: "NOK",
        BW: "BWP",
        WS: "WST",
        BQ: "USD",
        BR: "BRL",
        BS: "BSD",
        JE: "GBP",
        BY: "BYR",
        BZ: "BZD",
        RU: "RUB",
        RW: "RWF",
        RS: "RSD",
        TL: "USD",
        RE: "EUR",
        TM: "TMT",
        TJ: "TJS",
        RO: "RON",
        TK: "NZD",
        GW: "XOF",
        GU: "USD",
        GT: "GTQ",
        GS: "GBP",
        GR: "EUR",
        GQ: "XAF",
        GP: "EUR",
        JP: "JPY",
        GY: "GYD",
        GG: "GBP",
        GF: "EUR",
        GE: "GEL",
        GD: "XCD",
        GB: "GBP",
        GA: "XAF",
        SV: "USD",
        GN: "GNF",
        GM: "GMD",
        GL: "DKK",
        GI: "GIP",
        GH: "GHS",
        OM: "OMR",
        TN: "TND",
        JO: "JOD",
        HR: "EUR",
        HT: "HTG",
        HU: "HUF",
        HK: "HKD",
        HN: "HNL",
        HM: "AUD",
        VE: "VES",
        PR: "USD",
        PS: "ILS",
        PW: "USD",
        PT: "EUR",
        SJ: "NOK",
        PY: "PYG",
        IQ: "IQD",
        PA: "PAB",
        PF: "XPF",
        PG: "PGK",
        PE: "PEN",
        PK: "PKR",
        PH: "PHP",
        PN: "NZD",
        PL: "PLN",
        PM: "EUR",
        ZM: "ZMK",
        EH: "MAD",
        EE: "EUR",
        EG: "EGP",
        ZA: "ZAR",
        EC: "USD",
        IT: "EUR",
        VN: "VND",
        SB: "SBD",
        ET: "ETB",
        SO: "SOS",
        ZW: "ZWL",
        SA: "SAR",
        ES: "EUR",
        ER: "ERN",
        ME: "EUR",
        MD: "MDL",
        MG: "MGA",
        MF: "EUR",
        MA: "MAD",
        MC: "EUR",
        UZ: "UZS",
        MM: "MMK",
        ML: "XOF",
        MO: "MOP",
        MN: "MNT",
        MH: "USD",
        MK: "MKD",
        MU: "MUR",
        MT: "EUR",
        MW: "MWK",
        MV: "MVR",
        MQ: "EUR",
        MP: "USD",
        MS: "XCD",
        MR: "MRO",
        IM: "GBP",
        UG: "UGX",
        TZ: "TZS",
        MY: "MYR",
        MX: "MXN",
        IL: "ILS",
        FR: "EUR",
        IO: "USD",
        SH: "SHP",
        FI: "EUR",
        FJ: "FJD",
        FK: "FKP",
        FM: "USD",
        FO: "DKK",
        NI: "NIO",
        NL: "EUR",
        NO: "NOK",
        NA: "NAD",
        VU: "VUV",
        NC: "XPF",
        NE: "XOF",
        NF: "AUD",
        NG: "NGN",
        NZ: "NZD",
        NP: "NPR",
        NR: "AUD",
        NU: "NZD",
        CK: "NZD",
        XK: "EUR",
        CI: "XOF",
        CH: "CHF",
        CO: "COP",
        CN: "CNY",
        CM: "XAF",
        CL: "CLP",
        CC: "AUD",
        CA: "CAD",
        CG: "XAF",
        CF: "XAF",
        CD: "CDF",
        CZ: "CZK",
        CY: "EUR",
        CX: "AUD",
        CR: "CRC",
        CW: "XCG",
        CV: "CVE",
        CU: "CUP",
        SZ: "SZL",
        SY: "SYP",
        SX: "XCG",
        KG: "KGS",
        KE: "KES",
        SS: "SSP",
        SR: "SRD",
        KI: "AUD",
        KH: "KHR",
        KN: "XCD",
        KM: "KMF",
        ST: "STD",
        SK: "EUR",
        KR: "KRW",
        SI: "EUR",
        KP: "KPW",
        KW: "KWD",
        SN: "XOF",
        SM: "EUR",
        SL: "SLL",
        SC: "SCR",
        KZ: "KZT",
        KY: "KYD",
        SG: "SGD",
        SE: "SEK",
        SD: "SDG",
        DO: "DOP",
        DM: "XCD",
        DJ: "DJF",
        DK: "DKK",
        VG: "USD",
        DE: "EUR",
        YE: "YER",
        DZ: "DZD",
        US: "USD",
        UY: "UYU",
        YT: "EUR",
        UM: "USD",
        LB: "LBP",
        LC: "XCD",
        LA: "LAK",
        TV: "AUD",
        TW: "TWD",
        TT: "TTD",
        TR: "TRY",
        LK: "LKR",
        LI: "CHF",
        LV: "EUR",
        TO: "TOP",
        LT: "EUR",
        LU: "EUR",
        LR: "LRD",
        LS: "LSL",
        TH: "THB",
        TF: "EUR",
        TG: "XOF",
        TD: "XAF",
        TC: "USD",
        LY: "LYD",
        VA: "EUR",
        VC: "XCD",
        AE: "AED",
        AD: "EUR",
        AG: "XCD",
        AF: "AFN",
        AI: "XCD",
        VI: "USD",
        IS: "ISK",
        IR: "IRR",
        AM: "AMD",
        AL: "ALL",
        AO: "AOA",
        AS: "USD",
        AR: "ARS",
        AU: "AUD",
        AT: "EUR",
        AW: "AWG",
        IN: "INR",
        AX: "EUR",
        AZ: "AZN",
        IE: "EUR",
        ID: "IDR",
        UA: "UAH",
        QA: "QAR",
        MZ: "MZN"
    };
    const currencyFormats = {
        "AED": {
            "money_format": "Dhs. {{amount}}",
            "money_with_currency_format": "Dhs. {{amount}} AED"
        },
        "AFN": {
            "money_format": "&#65;&#102; {{amount}}",
            "money_with_currency_format": "&#65;&#102; {{amount}} AFN"
        },
        "ALL": {
            "money_format": "Lek {{amount}}",
            "money_with_currency_format": "Lek {{amount}} ALL"
        },
        "AMD": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} AMD"
        },
        "ANG": {
            "money_format": "&fnof;{{amount}}",
            "money_with_currency_format": "{{amount}} NA&fnof;"
        },
        "XCG": {
            "money_format": "Cg {{amount}}",
            "money_with_currency_format": "Cg {{amount}} XCG"
        },
        "AOA": {
            "money_format": "Kz{{amount}}",
            "money_with_currency_format": "Kz{{amount}} AOA"
        },
        "ARS": {
            "money_format": "${{amount_with_comma_separator}}",
            "money_with_currency_format": "${{amount_with_comma_separator}} ARS"
        },
        "AUD": {
            "money_format": "A${{amount}}",
            "money_with_currency_format": "${{amount}} AUD"
        },
        "AWG": {
            "money_format": "Afl{{amount}}",
            "money_with_currency_format": "Afl{{amount}} AWG"
        },
        "AZN": {
            "money_format": "&#8380;{{amount}}",
            "money_with_currency_format": "&#8380;{{amount}} AZN"
        },
        "BAM": {
            "money_format": "KM {{amount_with_comma_separator}}",
            "money_with_currency_format": "KM {{amount_with_comma_separator}} BAM"
        },
        "BBD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} Bds"
        },
        "BDT": {
            "money_format": "Tk {{amount}}",
            "money_with_currency_format": "Tk {{amount}} BDT"
        },
        "BGN": {
            "money_format": "{{amount}} лв",
            "money_with_currency_format": "{{amount}} лв BGN"
        },
        "BHD": {
            "money_format": "{{amount}} BD",
            "money_with_currency_format": "{{amount}} BHD"
        },
        "BIF": {
            "money_format": "&#70;&#66;&#117; {{amount}}",
            "money_with_currency_format": "&#70;&#66;&#117; {{amount}} BIF"
        },
        "BMD": {
            "money_format": "&#36; {{amount}}",
            "money_with_currency_format": "&#36; {{amount}} BMD"
        },
        "BND": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} BND"
        },
        "BOB": {
            "money_format": "Bs{{amount_with_comma_separator}}",
            "money_with_currency_format": "Bs{{amount_with_comma_separator}} BOB"
        },
        "BRL": {
            "money_format": "R$ {{amount_with_comma_separator}}",
            "money_with_currency_format": "R$ {{amount_with_comma_separator}} BRL"
        },
        "BSD": {
            "money_format": "BS${{amount}}",
            "money_with_currency_format": "BS${{amount}} BSD"
        },
        "BTC": {
            "money_format": "{{amount_no_decimals}} BTC",
            "money_with_currency_format": "{{amount_no_decimals}} BTC"
        },
        "BTN": {
            "money_format": "Nu {{amount}}",
            "money_with_currency_format": "Nu {{amount}} BTN"
        },
        "BWP": {
            "money_format": "P{{amount}}",
            "money_with_currency_format": "P{{amount}} BWP"
        },
        "BYN": {
            "money_format": "Br {{amount}}",
            "money_with_currency_format": "Br {{amount}} BYN"
        },
        "BZD": {
            "money_format": "BZ${{amount}}",
            "money_with_currency_format": "BZ${{amount}} BZD"
        },
        "CAD": {
            "money_format": "C${{amount}}",
            "money_with_currency_format": "${{amount}} CAD"
        },
        "CDF": {
            "money_format": "&#70;&#67; {{amount}}",
            "money_with_currency_format": "&#70;&#67; {{amount}} CDF"
        },
        "CHF": {
            "money_format": "CHF {{amount}}",
            "money_with_currency_format": "CHF {{amount}}"
        },
        "CLP": {
            "money_format": "${{amount_no_decimals}}",
            "money_with_currency_format": "${{amount_no_decimals}} CLP"
        },
        "CNY": {
            "money_format": "&#165;{{amount}}",
            "money_with_currency_format": "&#165;{{amount}} CNY"
        },
        "COP": {
            "money_format": "${{amount_with_comma_separator}}",
            "money_with_currency_format": "${{amount_with_comma_separator}} COP"
        },
        "CRC": {
            "money_format": "&#8353; {{amount_with_comma_separator}}",
            "money_with_currency_format": "&#8353; {{amount_with_comma_separator}} CRC"
        },
        "CUC": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} CUC"
        },
        "CUP": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} CUP"
        },
        "CVE": {
            "money_format": "&#36; {{amount}}",
            "money_with_currency_format": "&#36; {{amount}} CVE"
        },
        "CZK": {
            "money_format": "{{amount_with_comma_separator}} K&#269;",
            "money_with_currency_format": "{{amount_with_comma_separator}} K&#269;"
        },
        "DJF": {
            "money_format": "&#70;&#100;&#106; {{amount}}",
            "money_with_currency_format": "&#70;&#100;&#106; {{amount}} DJF"
        },
        "DKK": {
            "money_format": "kr {{amount_with_comma_separator}}",
            "money_with_currency_format": "kr {{amount_with_comma_separator}} DKK"
        },
        "DOP": {
            "money_format": "RD$ {{amount}}",
            "money_with_currency_format": "RD$ {{amount}}"
        },
        "DZD": {
            "money_format": "DA {{amount}}",
            "money_with_currency_format": "DA {{amount}} DZD"
        },
        "EEK": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} EEK"
        },
        "EGP": {
            "money_format": "LE {{amount}}",
            "money_with_currency_format": "LE {{amount}} EGP"
        },
        "ERN": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} ERN"
        },
        "ETB": {
            "money_format": "Br{{amount}}",
            "money_with_currency_format": "Br{{amount}} ETB"
        },
        "EUR": {
            "money_format": "&euro;{{amount_with_comma_separator}}",
            "money_with_currency_format": "&euro;{{amount_with_comma_separator}} EUR"
        },
        "FJD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "FJ${{amount}}"
        },
        "FKP": {
            "money_format": "&#163; {{amount}}",
            "money_with_currency_format": "&#163; {{amount}} FKP"
        },
        "GBP": {
            "money_format": "&pound;{{amount}}",
            "money_with_currency_format": "&pound;{{amount}} GBP"
        },
        "GEL": {
            "money_format": "{{amount}} GEL",
            "money_with_currency_format": "{{amount}} GEL"
        },
        "GGP": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} GGP"
        },
        "GHS": {
            "money_format": "GH&#8373;{{amount}}",
            "money_with_currency_format": "GH&#8373;{{amount}}"
        },
        "GIP": {
            "money_format": "&#163; {{amount}}",
            "money_with_currency_format": "&#163; {{amount}} GIP"
        },
        "GMD": {
            "money_format": "D {{amount}}",
            "money_with_currency_format": "D {{amount}} GMD"
        },
        "GNF": {
            "money_format": "&#70;&#71; {{amount}}",
            "money_with_currency_format": "&#70;&#71; {{amount}} GNF"
        },
        "GTQ": {
            "money_format": "Q{{amount}}",
            "money_with_currency_format": "{{amount}} GTQ"
        },
        "GYD": {
            "money_format": "G${{amount}}",
            "money_with_currency_format": "${{amount}} GYD"
        },
        "HKD": {
            "money_format": "HK${{amount}}",
            "money_with_currency_format": "HK${{amount}} HKD"
        },
        "HNL": {
            "money_format": "L {{amount}}",
            "money_with_currency_format": "L {{amount}} HNL"
        },
        "HRK": {
            "money_format": "{{amount_with_comma_separator}}  kn",
            "money_with_currency_format": "{{amount_with_comma_separator}} kn HRK"
        },
        "HTG": {
            "money_format": "&#71; {{amount}}",
            "money_with_currency_format": "&#71; {{amount}} HTG"
        },
        "HUF": {
            "money_format": "{{amount_no_decimals_with_comma_separator}}",
            "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} Ft"
        },
        "IDR": {
            "money_format": "{{amount_with_comma_separator}} IDR",
            "money_with_currency_format": "Rp {{amount_with_comma_separator}} IDR"
        },
        "ILS": {
            "money_format": "&#8362;{{amount}}",
            "money_with_currency_format": "&#8362;{{amount}} NIS"
        },
        "IMP": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} IMP"
        },
        "INR": {
            "money_format": "&#8377; {{amount}}",
            "money_with_currency_format": "&#8377; {{amount}} INR"
        },
        "IQD": {
            "money_format": "&#1593;.&#1583; {{amount}}",
            "money_with_currency_format": "&#1593;.&#1583; {{amount}} IQD"
        },
        "IRR": {
            "money_format": "&#65020; {{amount}}",
            "money_with_currency_format": "&#65020; {{amount}} IRR"
        },
        "ISK": {
            "money_format": "{{amount_no_decimals}} kr",
            "money_with_currency_format": "{{amount_no_decimals}} kr ISK"
        },
        "JEP": {
            "money_format": "&pound;{{amount}}",
            "money_with_currency_format": "&pound;{{amount}} JEP"
        },
        "JMD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} JMD"
        },
        "JOD": {
            "money_format": "{{amount}} JD",
            "money_with_currency_format": "{{amount}} JOD"
        },
        "JPY": {
            "money_format": "&#165;{{amount_no_decimals}}",
            "money_with_currency_format": "&#165;{{amount_no_decimals}} JPY"
        },
        "KES": {
            "money_format": "KSh{{amount}}",
            "money_with_currency_format": "KSh{{amount}}"
        },
        "KGS": {
            "money_format": "лв{{amount}}",
            "money_with_currency_format": "лв{{amount}}"
        },
        "KHR": {
            "money_format": "KHR{{amount}}",
            "money_with_currency_format": "KHR{{amount}}"
        },
        "KMF": {
            "money_format": "&#67;&#70; {{amount}}",
            "money_with_currency_format": "&#67;&#70; {{amount}} KMF"
        },
        "KPW": {
            "money_format": "&#8361; {{amount}}",
            "money_with_currency_format": "&#8361; {{amount}} KPW"
        },
        "KRW": {
            "money_format": "&#8361;{{amount_no_decimals}}",
            "money_with_currency_format": "&#8361;{{amount_no_decimals}} KRW"
        },
        "KWD": {
            "money_format": "{{amount}} KD",
            "money_with_currency_format": "{{amount}} KWD"
        },
        "KYD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} KYD"
        },
        "KZT": {
            "money_format": "{{amount}} KZT",
            "money_with_currency_format": "{{amount}} KZT"
        },
        "LAK": {
            "money_format": "&#8365; {{amount}}",
            "money_with_currency_format": "&#8365; {{amount}} LAK"
        },
        "LBP": {
            "money_format": "L.L.{{amount}}",
            "money_with_currency_format": "L.L.{{amount}} LBP"
        },
        "LKR": {
            "money_format": "Rs {{amount}}",
            "money_with_currency_format": "Rs {{amount}} LKR"
        },
        "LRD": {
            "money_format": "&#36; {{amount}}",
            "money_with_currency_format": "&#36; {{amount}} LRD"
        },
        "LSL": {
            "money_format": "&#76; {{amount}}",
            "money_with_currency_format": "&#76; {{amount}} LSL"
        },
        "LTL": {
            "money_format": "{{amount}} Lt",
            "money_with_currency_format": "{{amount}} Lt"
        },
        "LVL": {
            "money_format": "Ls {{amount}}",
            "money_with_currency_format": "Ls {{amount}} LVL"
        },
        "LYD": {
            "money_format": "&#1604;.&#1583; {{amount}}",
            "money_with_currency_format": "&#1604;.&#1583; {{amount}} LYD"
        },
        "MAD": {
            "money_format": "{{amount}} dh",
            "money_with_currency_format": "Dh {{amount}} MAD"
        },
        "MDL": {
            "money_format": "{{amount}} MDL",
            "money_with_currency_format": "{{amount}} MDL"
        },
        "MGA": {
            "money_format": "Ar {{amount}}",
            "money_with_currency_format": "Ar {{amount}} MGA"
        },
        "MKD": {
            "money_format": "ден {{amount}}",
            "money_with_currency_format": "ден {{amount}} MKD"
        },
        "MMK": {
            "money_format": "K{{amount}}",
            "money_with_currency_format": "K{{amount}} MMK"
        },
        "MNT": {
            "money_format": "{{amount_no_decimals}} &#8366",
            "money_with_currency_format": "{{amount_no_decimals}} MNT"
        },
        "MOP": {
            "money_format": "MOP${{amount}}",
            "money_with_currency_format": "MOP${{amount}}"
        },
        "MRO": {
            "money_format": "&#85;&#77; {{amount}}",
            "money_with_currency_format": "&#85;&#77; {{amount}} MRO"
        },
        "MUR": {
            "money_format": "Rs {{amount}}",
            "money_with_currency_format": "Rs {{amount}} MUR"
        },
        "MVR": {
            "money_format": "Rf{{amount}}",
            "money_with_currency_format": "Rf{{amount}} MVR"
        },
        "MWK": {
            "money_format": "&#77;&#75; {{amount}}",
            "money_with_currency_format": "&#77;&#75; {{amount}} MWK"
        },
        "MXN": {
            "money_format": "$ {{amount}}",
            "money_with_currency_format": "$ {{amount}} MXN"
        },
        "MYR": {
            "money_format": "RM{{amount}}",
            "money_with_currency_format": "RM{{amount}} MYR"
        },
        "MZN": {
            "money_format": "{{amount}} Mt",
            "money_with_currency_format": "Mt {{amount}} MZN"
        },
        "NAD": {
            "money_format": "N${{amount}}",
            "money_with_currency_format": "N${{amount}} NAD"
        },
        "NGN": {
            "money_format": "&#8358;{{amount}}",
            "money_with_currency_format": "&#8358;{{amount}} NGN"
        },
        "NIO": {
            "money_format": "C${{amount}}",
            "money_with_currency_format": "C${{amount}} NIO"
        },
        "NOK": {
            "money_format": "kr {{amount_with_comma_separator}}",
            "money_with_currency_format": "kr {{amount_with_comma_separator}} NOK"
        },
        "NPR": {
            "money_format": "Rs{{amount}}",
            "money_with_currency_format": "Rs{{amount}} NPR"
        },
        "NZD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} NZD"
        },
        "OMR": {
            "money_format": "{{amount}} OMR",
            "money_with_currency_format": "{{amount}} OMR"
        },
        "PAB": {
            "money_format": "&#66;&#47;&#46; {{amount}}",
            "money_with_currency_format": "&#66;&#47;&#46; {{amount}} PAB"
        },
        "PEN": {
            "money_format": "S/. {{amount}}",
            "money_with_currency_format": "S/. {{amount}} PEN"
        },
        "PGK": {
            "money_format": "K {{amount}}",
            "money_with_currency_format": "K {{amount}} PGK"
        },
        "PHP": {
            "money_format": "&#8369;{{amount}}",
            "money_with_currency_format": "&#8369;{{amount}} PHP"
        },
        "PKR": {
            "money_format": "Rs.{{amount}}",
            "money_with_currency_format": "Rs.{{amount}} PKR"
        },
        "PLN": {
            "money_format": "{{amount_with_comma_separator}} zl",
            "money_with_currency_format": "{{amount_with_comma_separator}} zl PLN"
        },
        "PYG": {
            "money_format": "Gs. {{amount_no_decimals_with_comma_separator}}",
            "money_with_currency_format": "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
        },
        "QAR": {
            "money_format": "QAR {{amount_with_comma_separator}}",
            "money_with_currency_format": "QAR {{amount_with_comma_separator}}"
        },
        "RON": {
            "money_format": "{{amount_with_comma_separator}} lei",
            "money_with_currency_format": "{{amount_with_comma_separator}} lei RON"
        },
        "RSD": {
            "money_format": "{{amount}} RSD",
            "money_with_currency_format": "{{amount}} RSD"
        },
        "RUB": {
            "money_format": "&#8381; {{amount_with_comma_separator}}",
            "money_with_currency_format": "&#8381; {{amount_with_comma_separator}} RUB"
        },
        "RWF": {
            "money_format": "{{amount_no_decimals}} RF",
            "money_with_currency_format": "{{amount_no_decimals}} RWF"
        },
        "SAR": {
            "money_format": "{{amount}} SR",
            "money_with_currency_format": "{{amount}} SAR"
        },
        "SBD": {
            "money_format": "&#36; {{amount}}",
            "money_with_currency_format": "&#36; {{amount}} SBD"
        },
        "SCR": {
            "money_format": "Rs {{amount}}",
            "money_with_currency_format": "Rs {{amount}} SCR"
        },
        "SDG": {
            "money_format": "&#163; {{amount}}",
            "money_with_currency_format": "&#163; {{amount}} SDG"
        },
        "SEK": {
            "money_format": "kr {{amount_no_decimals}}",
            "money_with_currency_format": "kr {{amount_no_decimals}} SEK"
        },
        "SGD": {
            "money_format": "S${{amount}}",
            "money_with_currency_format": "S${{amount}} SGD"
        },
        "SHP": {
            "money_format": "&#163; {{amount}}",
            "money_with_currency_format": "&#163; {{amount}} SHP"
        },
        "SKK": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} SKK"
        },
        "SLL": {
            "money_format": "&#76;&#101; {{amount}}",
            "money_with_currency_format": "&#76;&#101; {{amount}} SLL"
        },
        "SOS": {
            "money_format": "&#83; {{amount}}",
            "money_with_currency_format": "&#83; {{amount}} SOS"
        },
        "SPL": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} SPL"
        },
        "SRD": {
            "money_format": "&#36; {{amount}}",
            "money_with_currency_format": "&#36; {{amount}} SRD"
        },
        "STD": {
            "money_format": "Db {{amount}}",
            "money_with_currency_format": "Db {{amount}} STD"
        },
        "SVC": {
            "money_format": "&#36; {{amount}}",
            "money_with_currency_format": "&#36; {{amount}} SVC"
        },
        "SYP": {
            "money_format": "S&pound;{{amount}}",
            "money_with_currency_format": "S&pound;{{amount}} SYP"
        },
        "SZL": {
            "money_format": "&#76; {{amount}}",
            "money_with_currency_format": "&#76; {{amount}} SZL"
        },
        "THB": {
            "money_format": "{{amount}} &#xe3f;",
            "money_with_currency_format": "{{amount}} &#xe3f; THB"
        },
        "TJS": {
            "money_format": "&#84;&#74;&#83; {{amount}}",
            "money_with_currency_format": "&#84;&#74;&#83; {{amount}} TJS"
        },
        "TMT": {
            "money_format": "&#109; {{amount}}",
            "money_with_currency_format": "&#109; {{amount}} TMT"
        },
        "TND": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} DT"
        },
        "TOP": {
            "money_format": "&#84;&#36; {{amount}}",
            "money_with_currency_format": "&#84;&#36; {{amount}} TOP"
        },
        "TRY": {
            "money_format": "{{amount}} TL",
            "money_with_currency_format": "{{amount}} TL"
        },
        "TTD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} TTD"
        },
        "TVD": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} TVD"
        },
        "TWD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} TWD"
        },
        "TZS": {
            "money_format": "{{amount}} TZS",
            "money_with_currency_format": "{{amount}} TZS"
        },
        "UAH": {
            "money_format": "₴{{amount}}",
            "money_with_currency_format": "₴{{amount}} UAH"
        },
        "UGX": {
            "money_format": "Ush {{amount_no_decimals}}",
            "money_with_currency_format": "Ush {{amount_no_decimals}} UGX"
        },
        "USD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} USD"
        },
        "UYU": {
            "money_format": "${{amount_with_comma_separator}}",
            "money_with_currency_format": "${{amount_with_comma_separator}} UYU"
        },
        "UZS": {
            "money_format": "&#1083;&#1074; {{amount}}",
            "money_with_currency_format": "&#1083;&#1074; {{amount}} UZS"
        },
        "VES": {
            "money_format": "Bs. {{amount_with_comma_separator}}",
            "money_with_currency_format": "Bs. {{amount_with_comma_separator}} VES"
        },
        "VND": {
            "money_format": "{{amount_no_decimals_with_comma_separator}}&#8363;",
            "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} VND"
        },
        "VUV": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}}VT"
        },
        "WST": {
            "money_format": "WS$ {{amount}}",
            "money_with_currency_format": "WS$ {{amount}} WST"
        },
        "XAF": {
            "money_format": "FCFA{{amount}}",
            "money_with_currency_format": "FCFA{{amount}} XAF"
        },
        "XAG": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} XAG"
        },
        "XAU": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} XAU"
        },
        "XCD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "EC${{amount}}"
        },
        "XDR": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} XDR"
        },
        "XOF": {
            "money_format": "CFA{{amount}}",
            "money_with_currency_format": "CFA{{amount}} XOF"
        },
        "XPD": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} XPD"
        },
        "XPF": {
            "money_format": "{{amount_no_decimals_with_comma_separator}} XPF",
            "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} XPF"
        },
        "XPT": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} XPT"
        },
        "YER": {
            "money_format": "&#65020; {{amount}}",
            "money_with_currency_format": "&#65020; {{amount}} YER"
        },
        "ZAR": {
            "money_format": "R {{amount}}",
            "money_with_currency_format": "R {{amount}} ZAR"
        },
        "ZMW": {
            "money_format": "K{{amount_no_decimals_with_comma_separator}}",
            "money_with_currency_format": "ZMW{{amount_no_decimals_with_comma_separator}}"
        },
        "ZWD": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} ZWD"
        }
    };
    
    class CountriesSelector extends HTMLElement {
        constructor() {
            super();

            this.flag = false;
            this.country = 'US';
            this.currency = "USD";
            this.currencyRate = 1.0;
            this.countrySelectedEl = this.querySelector('.countries-selected');
            this.countriesItmList = this.querySelectorAll('.countries-item');
        }

        connectedCallback() {
            fetch(`${apiHost}/api/rate/list`, {
                "method": "get",
                "headers": { "Content-Type": "application/json" },
            })
            .then(response => response.json())
            .then(data => {
                if (data.status == 'ok') {
                    this.currencyRateMap = data.result;
                }
            })
            .catch(error => console.error(error))
            .finally(() => {
                this.init();
            });
        }

        init() {
            this.addEvent();

            this.domReady(() => {
                if (curent_country) this.country = curent_country;
                const currency = cmap[`${this.country}`];
                const currencyRate = this.currencyRateMap[`${currency}`];
                if (!this.flag && Shopify.country) {
                    const code2 = Shopify.country.toLowerCase();
                    const autoLcationEl = this.querySelector('.countries-item.geo-currency');
                    autoLcationEl.querySelector('.countries-icon').src = `${apiHost}/countries/${code2}.svg`;
                    autoLcationEl.dataset.currency = cmap[`${Shopify.country}`];
                    autoLcationEl.dataset.code = code2;
                }
 
                this.initDom(currency, currencyRate, this.country.toLocaleLowerCase());
                
                this.flag = true;
            });
        }

        initDom(currency, currencyRate, code) {
            if (currencyRate) {
                this.currency = currency;
                this.currencyRate = currencyRate;
                this.moneyCurrencyFormat = currencyFormats[`${this.currency}`]["money_format"];

                window.moneyCurrency = this.currency;
                window.moneyCurrencyFormat = this.moneyCurrencyFormat;
                window.moneyCrrencyRate = this.currencyRate;
                this.resetDefaultDom(this.currency, code);
                this.initAllMoneySelector();
            }
        }

        addEvent() {
            this.countrySelectedEl.addEventListener('click', (e) => {
                const targetEl = e.currentTarget;
                if (targetEl.parentNode.classList.contains('active')) {
                    targetEl.parentNode.classList.remove('active');
                } else {
                    targetEl.parentNode.classList.add('active');
                }
            });
            this.countriesItmList.forEach((item) => {
                item.addEventListener('click', (e) => {
                    if (this.flag) {
                        const targetEl = e.currentTarget;
                        const currency = targetEl.dataset.currency;
                        const cuounry = targetEl.dataset.code;
                        const currencyRate = this.currencyRateMap[`${currency}`];
                        this.initDom(currency, currencyRate, cuounry);
                        window.localStorage.setItem('country', cuounry);
                    }
                    this.classList.remove('active');
                });
            });

            window.addEventListener('click', (e)=> {
                if (!this.contains(e.target) && this.classList.contains('active')) {
                    this.classList.remove('active');
                }
            });
        }

        resetDefaultDom(currency, code) {
            this.countrySelectedEl.querySelector('.countries-icon').src = `${apiHost}/countries/${code}.svg`;
            this.countrySelectedEl.querySelector('.countries-currency').innerText = currency;
        }

        initAllMoneySelector() {
            const allMoneyEl = document.querySelectorAll('span.money, .fmoney');
            allMoneyEl.forEach((moneyEl) => {
                const originalMoney = !this.flag ? (moneyEl.innerText || moneyEl.textContent).trim() : moneyEl.getAttribute('rate-original').trim();                        
                const initMoney = originalMoney ? originalMoney.replace(/[^0-9.]/g, '') : '0.00';
                
                if (!this.flag) {
                  moneyEl.classList.add('rate-money');
                  moneyEl.setAttribute('rate-original', originalMoney);
                  moneyEl.setAttribute('rate-init', initMoney);
                }
                moneyEl.setAttribute('rate-currency', this.currency);

                const newMoney = parseFloat(initMoney) * this.currencyRate;
                moneyEl.innerHTML = ( (moneyEl.getAttribute('rate-original').indexOf('From') > -1 ? "From " : "") + this.moneyCurrencyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, newMoney.toFixed(2)) );
            });
        }

        domReady(callback) {
            if (document.readyState != 'loading') callback();
            else document.addEventListener('DOMContentLoaded', callback);
        }
    }
    customElements.define('countries-selector', CountriesSelector);
}

if (!customElements.get("search-introduce")) {
  class CustomSerachIntroduce extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const search_introduce = window.localStorage.getItem('search_introduce');
      if (search_introduce && typeof gtag === 'function') {
        gtag('event', 'search_introduce');
        window.localStorage.removeItem('search_introduce');
      }
      if (document.readyState != 'loading'){
          this.init();
      } else {
          document.addEventListener('DOMContentLoaded', this.init);
      }
    }
    init() {
      this.addSearchDiscovery();
      this.addSearchPlaceholderScroll();
      this.addSearchProducts();
    }
    addSearchDiscovery() {      
      if (search_introduces.length < 1) return;
      var html = '';
      this.classList.add('active');
      search_introduces.forEach(item => {
        if (item.link) {
          html += `<a class="search-discovery__item" data-word="${item.text}" href="${item.link}">` + (
            item.icon_text ? item.icon_text : (item.icon ? `<img class="search-discovery__icon" src="${item.icon}" width="80" height="80" />` : '')
          ) + `${item.text}</a>`;
        } else {
          html += `<span class="search-discovery__item" data-word="${item.text}">` + (
            item.icon_text ? item.icon_text : (item.icon ? `<img class="search-discovery__icon" src="${item.icon}" width="80" height="80" />` : '')
          ) + `${item.text}</span>`;
        }        
      });
      this.querySelector('.search-introduce__box').innerHTML = html;
      this.addDiscoveryItemEvent();
    }
    addDiscoveryItemEvent() {
      this.querySelectorAll('.search-discovery__item').forEach((item) => {
        item.addEventListener('click', (e) => {
          let word = item.dataset.word;
          window.localStorage.setItem('search_introduce', true);
          window.location.href = item.href ? item.href : this.getSearchQueryString(word);
        });      
      });    
    }
    addSearchPlaceholderScroll() {
      this.inputElement = document.body.querySelector('.predictive-search__input');
      this.placeholderLayer = document.getElementById("scrollPlaceholder");
      this.scrollList = this.placeholderLayer?.querySelector('.scroll-list');

      this.itemHeight = this.placeholderLayer ? this.placeholderLayer.clientHeight : 0;
      this.currentIndex = 0;
      this.scrollInterval = null;      

      this.inputElement.addEventListener("focus", () => {
        this.placeholderLayer.style.display = "none";
        if (searchKeywords.length < 1) return;
        this.inputElement.value = searchKeywords[this.currentIndex];
        const inputEvent = new Event('input', { bubbles: true });
        this.inputElement.dispatchEvent(inputEvent);
        this.stopScrolling();
      });

      this.inputElement.addEventListener("blur", () => {
        if (this.inputElement.value.trim() === "") {
          this.placeholderLayer.style.display = "flex";
          if (searchKeywords.length < 1) return;
          this.startScrolling();
        }
      });
      
      this.initScrollList();
      this.startScrolling();
    }
    initScrollList() {
      if (searchKeywords.length < 1) return;
      const wordsToRender = [...searchKeywords, searchKeywords[0]];
      this.scrollList.innerHTML = wordsToRender.map(word => `<li>${word}</li>`).join("");
    }
    scrollNext() {
      this.currentIndex++;
      this.scrollList.style.transition = "transform 0.5s ease-in-out";
      this.scrollList.style.transform = `translateY(-${this.currentIndex * this.itemHeight}px)`;

      if (this.currentIndex === searchKeywords.length) {
        setTimeout(() => {
          this.scrollList.style.transition = "none";
          this.scrollList.style.transform = `translateY(0)`;
          this.currentIndex = 0;
        }, 500);
      }
    }
    startScrolling() {
      if (searchKeywords.length < 1) return;
      this.scrollInterval = window.setInterval(() => this.scrollNext(), 5000);
    }
    stopScrolling() {
      window.clearInterval(this.scrollInterval);
    }
    addSearchProducts() {
      this.introduceProducts = document.body.querySelector('.search-products');
      this.renderSearchProduct();
    }
    renderSearchProduct() {
      if (!searchProducts) return;
      this.introduceProducts .removeAttribute('hidden');
      this.introduceProducts.innerHTML = searchProducts;
      if (typeof resetMoneyCurrency === "function") {
        resetMoneyCurrency(this.introduceProducts);
      }
    }
    getSearchQueryString(word) {
      const url = new URL('/search', window.location.origin);
      url.searchParams.append('q', word);
      return url.toString();
    }
  }
  customElements.define('search-introduce', CustomSerachIntroduce);
}
